import { Redirect, Router } from "@reach/router";
import IndexPage from "./pages";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import KeyGeneratorPage from "./pages/key-generator";

const getRoutes: (user: User | null) => JSX.Element = () => {
  const defaultLink = "/";

  return (
    <Router>
      <Redirect from="/spa/pgp-ui-portlet" to={defaultLink} noThrow />
      <NotFound default />
      <IndexPage path="/" />
      <KeyGeneratorPage path="/key-generator" />
    </Router>
  );
};

export default getRoutes;
